// extracted by mini-css-extract-plugin
export default {"title":"rV960_","subtitle":"FCPT4e","progressBarWrapper":"FvYbMZ","textSecondary":"s2LLEu","desktopText":"d3666u"};